module.exports = __webpack_public_path__ + "static/media/tick.02cc194d.svg";